import Axios from "axios";
import { antdAsyncMessageError, antdAsyncMessageLoading, antdAsyncMessageSuccess } from "../../helpers/AsyncMessage";
import { validBulkAction } from "./bulk_shipment_action";


export const orderActionLogRegenerate = async (uuid) => {
    const key = "orderActionLogRegenerate";
    try {
        antdAsyncMessageLoading({ key });
        const { data } = await Axios.post(
            `/api/v1/action_logs/${uuid}/regenerate`
        );

        if (!data.success) throw new Error("ERR");
        antdAsyncMessageSuccess({ key });
        return { success: true };
    } catch (err) {
        console.log(`${key}: ${err}`);
        antdAsyncMessageError({ key });
        return {
            success: false,
        };
    }
};

export const orderActionLogUpdate = (id) => async (dispatch) => {
    const key = "orderActionLogUpdate";
    try {
        antdAsyncMessageLoading({ key });

        const values = await dispatch(validBulkAction())
        console.log({ values })
        if (!values.success) throw new Error("ERR");

        const { data } = await Axios.put(
            `/api/v1/action_logs/${id}`, values.params
        );

        if (!data.success) throw new Error("ERR");
        antdAsyncMessageSuccess({ key });
        return { success: true };
    } catch (err) {
        console.log(`${key}: ${err}`);
        antdAsyncMessageError({ key });
        return {
            success: false,
        };
    }
};

export const orderActionLogDelete = async (uuid, id) => {
    const key = "orderActionLogDelete";
    try {
        antdAsyncMessageLoading({ key });
        const { data } = await Axios.delete(
            `/api/v1/action_logs/${uuid || id}`
        );

        if (!data.success) throw new Error("ERR");
        antdAsyncMessageSuccess({ key });
        return { success: true };
    } catch (err) {
        console.log(`${key}: ${err}`);
        antdAsyncMessageError({ key });
        return {
            success: false,
        };
    }
};